// export const API = 'http://localhost:9090/api';
export const API = 'https://dev.mapout.com/mapout-node/api';
export const API_JOB = 'https://dev.mapout.com/mapout-node';
export const SERVER = 'https://dev.mapout.com';
export const CDN = `https://dmtj8dkxz1o8x.cloudfront.net`;
export const MEDIUM_API = `https://api.rss2json.com/v1/api.json?rss_url=https://medium.com/feed/@mapoutcareers`;
export const UPLOAD_SERVER = 'https://dev.mapout.com/mapout-upload/api';
